import { trpc as ApplicationExit } from '@tencent/tpro_rmonitor_web_server_application_exit';
import { WithTypeCast } from '@raft/utils';

export type IGetReportListReq = WithTypeCast<ApplicationExit.rmonitor.web_server.IGetReportListReq>;
export type IGetReportListRsp = WithTypeCast<ApplicationExit.rmonitor.web_server.IGetReportListRsp>;
export type IReportInfo = WithTypeCast<ApplicationExit.rmonitor.web_server.IReportInfo>;

export type IGetReportDetailReq = WithTypeCast<ApplicationExit.rmonitor.web_server.IGetReportDetailReq>;
export type IGetReportDetailRsp = WithTypeCast<ApplicationExit.rmonitor.web_server.IGetReportDetailRsp>;
export type IDetailInfo = WithTypeCast<ApplicationExit.rmonitor.web_server.IDetailInfo>;
export const { Architecture } = ApplicationExit.rmonitor.web_server;
